import OnPremAgentClient from '~/api/OnPremAgentClient/OnPremAgentClient'
import { DataIngestor } from '~/api/onPremAgent/dataIngestorsAPI'
import useOnPremAgentQuery from '~/api/onPremAgent/useOnPremAgentQuery'
import MinimalButton from '~/components/buttons/MinimalButton'
import { FullPageError } from '~/components/Errors'
import AddIcon from '~/components/icons/AddIcon'
import LoadingMessage from '~/components/LoadingMessage'
import OnPremAgentBreadcrumbs from '../components/OnPremAgentBreadcrumbs'
import DataIngestorsTable from './DataIngestorsTable'
import cs from './data_ingestors_list.scss'

export default function DataIngestorsList() {
  let { loading, error, data } = useOnPremAgentQuery<null, DataIngestor[]>({
    backendQueryParams: {
      apiQuery: async (client: OnPremAgentClient) =>
        client.dataIngestors.listDataIngestors(),
      apiParams: null,
    },
  })
  if (error) {
    return <FullPageError error={error} />
  }
  return (
    <div className={cs.dataIngestorsList}>
      <div className={cs.topBar}>
        <div className={cs.controls}>
          <OnPremAgentBreadcrumbs />
          <div className={cs.spacer} />
          <MinimalButton
            label='Create Data Ingestor'
            className={cs.searchInput}
            variant='normal'
            IconComponent={AddIcon}
            to='/data-ingestors/create'
          />
        </div>
      </div>
      {loading && (
        <LoadingMessage
          className={cs.loadingMessage}
          label={'Loading data ingestors...'}
        />
      )}
      {!loading && <Content dataIngestors={data || []} />}
    </div>
  )
}

function Content(props: { dataIngestors: DataIngestor[] }) {
  const { dataIngestors } = props
  return (
    <div className={cs.content}>
      <div className={cs.tableWrapper}>
        <DataIngestorsTable dataIngestors={dataIngestors} />
      </div>
    </div>
  )
}
